import { render, staticRenderFns } from "./wheel-seg.vue?vue&type=template&id=495ef10a"
import script from "./wheel-seg.vue?vue&type=script&lang=js"
export * from "./wheel-seg.vue?vue&type=script&lang=js"
import style0 from "./wheel-seg.vue?vue&type=style&index=0&id=495ef10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports